import type { PropsWithChildren } from "react";
import { Icon } from "@circle-react-shared/Icon";

export const Arrow = ({ children }: PropsWithChildren<unknown>) => (
  <div className="inline-block">
    <Icon type="16-arrow-right" size={16} />
    {children}
  </div>
);
